import { connect } from 'react-redux'
import gtm from '@blazar/tracking-google-tagmanager'

const environmentMap = {
  dev: 'development',
  qa: 'qa',
  prod: 'production',
}

const mapStateToProps = (state) => ({
  environment: state.config.tealium.environment && environmentMap[state.config.tealium.environment],
})

export default connect(mapStateToProps)(gtm.configurator)
